/* eslint-disable max-len */
import styled, {css} from 'styled-components';
import {
    breakpoints,
    mobileMediaQuery,
    notWebMediaQuery,
    tabletMediaQuery,
    webMediaQuery,
} from '../../styles';

export const Container = styled.div`
    position: relative;

    ::-webkit-scrollbar {
        display: none;
    }

    .scroll-container {
        padding: 8px 0;
        margin: 0px;

        ${webMediaQuery} {
            ${({isGames}) =>
                isGames &&
                css`
                    padding: 6px 8px 8px 8px;
                `}
        }

        ${tabletMediaQuery} {
            margin-left: -40px;
            padding-left: 40px;
        }

        ${mobileMediaQuery} {
            margin-left: -25px;
            padding-left: 25px;
        }
    }

    #games-grid {
        width: max-content;
        min-width: ${props => props.gridWidth || 0}px;
        grid-auto-flow: column;
        margin: 0px;
        padding-right: 16px;
        align-items: stretch;

        grid-template-columns: repeat(
            auto-fill,
            calc((100vw - 80px - (16px * 17)) / 18)
        );

        & > * {
            scroll-snap-align: center;
            grid-column: auto / span 3;
            height: 0 !important;
            padding-bottom: calc(207 / 259 * 100%) !important;

            :last-child {
                margin-right: 16px;
            }

            ${mobileMediaQuery} {
                :last-child {
                    margin-right: 8px;
                }
            }
        }

        @media screen and (min-width: ${breakpoints.xl}px) {
            grid-template-columns: repeat(
                auto-fill,
                ${props =>
                    props.brand === 'dkids'
                        ? 'calc((1440px - 80px - (16px * 11)) / 12)'
                        : 'calc((1440px - 80px - (16px * 17)) / 18)'}
            );
        }

        @media screen and (min-width: ${breakpoints.lg}px) and (max-width: ${breakpoints.xl}px) {
            grid-template-columns: repeat(
                auto-fill,
                ${props =>
                    props.brand === 'dkids'
                        ? 'calc((100vw - 80px - (16px * 11)) / 12)'
                        : 'calc((100vw - 80px - (16px * 17)) / 18)'}
            );
        }

        @media screen and (min-width: ${breakpoints.md}px) and (max-width: ${breakpoints.lg}px) {
            grid-template-columns: repeat(
                auto-fill,
                ${props =>
                    props.brand === 'dkids'
                        ? 'calc((100vw - 80px - (16px * 11)) / 12)'
                        : 'calc((100vw - 80px - (16px * 14)) / 15)'}
            );
        }

        @media screen and (min-width: ${breakpoints.sm}px) and (max-width: ${breakpoints.md}px) {
            grid-template-columns: repeat(
                auto-fill,
                calc((100vw - 80px - (16px * 11)) / 12)
            );

            & > * {
                padding-bottom: calc(188 / 224 * 100%) !important;
            }
        }

        @media screen and (min-width: ${breakpoints.mobile}px) and (max-width: ${breakpoints.sm}px) {
            grid-template-columns: repeat(
                auto-fill,
                calc((100vw - 80px - (16px * 8)) / 9)
            );

            & > * {
                padding-bottom: calc(185 / 219 * 100%) !important;
            }
        }

        ${mobileMediaQuery} {
            grid-template-columns: repeat(
                auto-fill,
                calc((100vw - 50px - (8px * 5)) / 6)
            );
            margin: 0px;

            & > * {
                padding-bottom: calc(141 / 159 * 100%) !important;
            }
        }

        ${props =>
            props.brand === 'dkids' &&
            css`
                & > * {
                    padding-bottom: calc(25px + 123 / 226 * 100%) !important;
                }
            `}
    }
`;

export const LeftControls = styled.div`
    position: absolute;
    top: ${props => (props.brand === 'dkids' ? '50%' : '37%')};
    left: 0px;
    transform: translate(-50%, -50%);
    width: 0px;
    height: 0px;
    overflow: visible;
    z-index: 5;
`;

export const RightControls = styled(LeftControls)`
    left: initial;
    right: 0px;
    transform: translate(-50%, -50%);
`;

export const ButtonPrev = styled.button`
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    border: none;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0.7);
    box-sizing: border-box;
    cursor: pointer;
    padding: 0px;

    margin: auto;
    left: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: 6px;
    svg {
        width: 18px;
        height: 28px;
        transform: ${props =>
            props.brand === 'dkids' ? 'scale(1)' : 'scaleX(-1)'};
        path {
            fill: ${props => (props.brand === 'dkids' ? 'white' : 'black')};
        }
        margin: auto;
    }

    ${props =>
        props.brand === 'dkids' &&
        css`
            background-color: rgba(0, 0, 0, 0.5);
            border-radius: 50%;
            left: 4px;
            padding-right: 0px;
        `};

    ${notWebMediaQuery} {
        display: none;
    }

    ${({disabled}) =>
        disabled &&
        css`
            cursor: initial;
            opacity: 0.45;
        `}
`;

export const ButtonNext = styled(ButtonPrev)`
    padding-right: initial;
    padding-left: 6px;
    left: -16px;

    svg {
        transform: ${props =>
            props.brand === 'dkids' ? 'scaleX(-1)' : 'initial'};
    }

    ${props =>
        props.brand === 'dkids' &&
        css`
            left: -4px;
        `};
`;
